import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailDocumentDpEvent } from '../dto/trail-document-dp-event';

@Injectable({
  providedIn: 'root'
})
export class TrailDocumentDpEventService {

  private apiUrl = environment.apiRoot + '/trialdocudpevent';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(trialId: number): Observable<TrailDocumentDpEvent[]> {
    return this.http.get<TrailDocumentDpEvent[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createDocumentDpEvent(trailId: number): Observable<TrailDocumentDpEvent> {
    let model = { "id": 0, "trial_id": trailId, "name": "new DP Event" };
    return this.http.post<TrailDocumentDpEvent>(this.apiUrl + '/new', model);
  }

  updateDocumentDpEvent(model: TrailDocumentDpEvent): Observable<TrailDocumentDpEvent> {
    return this.http.put<TrailDocumentDpEvent>(this.apiUrl + '/update', model);
  }

  deleteDocumentDpEvent(trialDocumentDpEventId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialDocuDpEventlId=' + trialDocumentDpEventId);
  }
}
